import React from "react";
import { DotLegalTextField } from "@dotlegal/dotlegal-ui-components";
import { IncidentLogNotificationAnswer } from "../../../incidentLog/IncidentLogDialog.types.ts";
import IncidentLogNotificationAnswerField from "./IncidentLogNotificationAnswerField.tsx";
import IncidentLogDateTimeField from "./IncidentLogDateTimeField.tsx";
import { isNotificationGiven, showsNotificationDescription } from "./incidentLogNotificationVisibility.ts";

export interface IncidentLogNotificationDate {
    label: string;
    date?: Date | null;
    time?: Date | null;
    onDateChange: (date: Date | null) => void;
    onTimeChange: (time: Date | null) => void;
}

export interface IncidentLogNotificationFieldProps {
    answerLabel: string;
    givenDescriptionLabel: string;
    notGivenDescriptionLabel: string;
    answer?: IncidentLogNotificationAnswer | null;
    dates: Array<IncidentLogNotificationDate>;
    description?: string | null;
    onAnswerChange: (answer: IncidentLogNotificationAnswer) => void;
    onDescriptionChange: (description: string) => void;
    isPreview: boolean;
    disabled: boolean;
    errorText?: string;
}

function IncidentLogNotificationField(props: IncidentLogNotificationFieldProps) {
    const isGiven = isNotificationGiven(props.answer, props.isPreview);

    return (
        <>
            <IncidentLogNotificationAnswerField
                label={props.answerLabel}
                answer={props.answer}
                onChange={props.onAnswerChange}
                disabled={props.disabled}
                errorText={props.errorText}
            />
            {isGiven &&
                props.dates.map((notificationDate) => (
                    <IncidentLogDateTimeField
                        key={notificationDate.label}
                        label={notificationDate.label}
                        date={notificationDate.date}
                        time={notificationDate.time}
                        onDateChange={notificationDate.onDateChange}
                        onTimeChange={notificationDate.onTimeChange}
                        disabled={props.disabled}
                    />
                ))}
            {showsNotificationDescription(props.answer, props.isPreview) && (
                <DotLegalTextField
                    label={isGiven ? props.givenDescriptionLabel : props.notGivenDescriptionLabel}
                    value={props.description ?? ""}
                    debounce
                    multiline
                    rows={3}
                    onChange={props.onDescriptionChange}
                    disabled={props.disabled}
                />
            )}
        </>
    );
}

export default IncidentLogNotificationField;
